import React from "react";
import { Reveal } from "./Reveal";
import { StoreBadges } from "./StoreBadges";
import { AppStoreQR } from "./AppStoreQR";

export const Download = () => (
  <section id="download" className="px-6 pb-20 pt-8 md:px-12 md:pb-28 md:pt-12" data-testid="download-section">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 rounded-[2.5rem] border border-[#E8EBE9] bg-white p-8 md:flex-row md:items-center md:justify-between md:p-14">
      <div className="max-w-xl">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">Get the app</p>
          <h2 className="font-heading mt-4 text-4xl font-semibold tracking-tight text-[#111E16] md:text-5xl">
            Download SisterSafe
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[#4A5F52] md:text-lg">
            Available now on iPhone. Android is coming soon to Google Play.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <StoreBadges testPrefix="download" className="mt-8" />
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <AppStoreQR size={148} testPrefix="download" />
      </Reveal>
    </div>
  </section>
);
